import { type LendingLoanListLoansData } from '@column/api';

export type LoanDropdownQuery = NonNullable<LendingLoanListLoansData['query']>;

export const loanQueryKey = (id: string) => ['loan', id] as const;

export const loanDropdownBaseQueryKey = ['loanDropdown'] as const;

export const loanDropdownListQueryKey = (platformId?: string, isSandbox?: boolean, query?: LoanDropdownQuery) =>
  [...loanDropdownBaseQueryKey, 'list', platformId, isSandbox, query] as const;

export const loanDropdownGetQueryKey = (id?: string, platformId?: string, isSandbox?: boolean) =>
  [...loanDropdownBaseQueryKey, 'get', id, platformId, isSandbox] as const;
